export default {"src":"/_next/static/media/email.b3540d27.svg","height":12,"width":20,"blurWidth":0,"blurHeight":0};